export default __webpack_public_path__ + "static/media/e3-posters-bg.b069650d.jpg";